export default __webpack_public_path__ + "static/media/Page2.e4430653.txt";